import { Preferences } from "@capacitor/preferences";

// Cap Preferences = native KeyChain (iOS) / SharedPreferences (Android),
// localStorage on web. Always async.
export const store = {
  async get<T = unknown>(key: string): Promise<T | null> {
    try {
      const { value } = await Preferences.get({ key });
      if (value == null) return null;
      try { return JSON.parse(value) as T; } catch { return value as unknown as T; }
    } catch {
      return null;
    }
  },
  async set(key: string, value: unknown) {
    await Preferences.set({ key, value: typeof value === "string" ? value : JSON.stringify(value) });
  },
  async del(key: string) {
    await Preferences.remove({ key });
  }
};
